// Box (milk carton): a stack to build with
import { definePart } from '../core/registry';
import { Physics } from '../core/physics';
import { block, rr } from '../core/draw-helpers';
import type { Ctx2D } from '../core/types';

export function drawBox(ctx: Ctx2D, x: number, y: number, a: number, w: number, h: number, sel?: boolean) {
  block(ctx, x, y, w, h, a, '#FFFFFF', '#CFE3FF', 8, { outline: sel ? '#fff' : null });
  ctx.save(); ctx.translate(x, y); ctx.rotate(a);
  ctx.fillStyle = '#5AA9FF'; rr(ctx, -w / 2, -h / 2 + 10, w, 18, 3); ctx.fill();
  ctx.fillStyle = '#fff'; ctx.beginPath(); ctx.arc(0, 8, 9, 0, 7); ctx.fill();
  ctx.restore();
}

export const box = definePart({
  rects: [{ x: 0, y: 0, w: 56, h: 90 }], rot: true, chamfer: 8, thumb: false,
  draw(ctx, pl, sel) { const r = Physics.worldRects(pl)[0]; drawBox(ctx, r.x, r.y, r.a, r.w, r.h, sel); },
  icon: ctx => drawBox(ctx, 0, 0, 0, 40, 64),
});
